import  { useState } from "react";
import "./index.css"
import GenAISidebar from "./GenAISidebar"
import GenAIAuthoring2Index from "./GenAIAuthoring2.0Index"

export default function GenAIAuthoring2Home(props) {
    const [customWidth] = useState(props.customWidth);
    const [customHeight] = useState(props.customHeight);


    if (customWidth >= 600 && customWidth <= 1000) {
        return (<></>)
    }
    else if (customWidth > 1000) {
        return (<div className="gen-ai-answering-container">
            <GenAISidebar customWidth={customWidth} customHeight={customHeight} />
            <GenAIAuthoring2Index customWidth={customWidth} customHeight={customHeight} />
        </div>)
    }

}
